<template>
  <Layout>
    <!-- <Appdowload ></Appdowload> -->
    <div class="bordertop3" v-if="!show_ie">
      <div class="header">
        <HeaderNav name="4"></HeaderNav>
      </div>
      <div>
        <!--<div class="search">-->
        <!--<div class="inlineblock search-input">-->
        <!--<input placeholder="请输入关键词" type="text" name="keyword" />-->
        <!--</div>-->
        <!--<button class="search-button" >搜索</button>-->
        <!--</div>-->

        <div class="mall" :style="list.length<=4?'height:900px':''">
          <div class="mall-bar">
            <ul>
              <!--<a href="javascropt:;" ><li @click="changeTab(0)" class="inlineblock mall-bar-item" :class="{active:cate_id==0}"  >全部</li></a>-->
              <a v-for="(cate,cate_key) in cate_list" :key="cate_key">
                <li
                  @click="changeTab(cate.id)"
                  class="inlineblock mall-bar-item"
                  :class="{active:cate_id==cate.id}"
                >{{cate.product_category_name}}</li>
              </a>
            </ul>
          </div>
          <div style="margin-top: 25px;">
            <div class="mall-list">
              <!--item start-->
              <div v-for="(item,item_key) in list" :key="item_key" class="mall-list-item">
                <router-link :to="{path:'/mall/detail',query:{id:item.id}}">
                  <div class="img">
                    <img
                      v-if="item.image_url!=undefined&&item.image_url.length>0"
                      :src="item.image_url[0]"
                    />
                    <img v-else src="https://file.jkxuetang.com/khyoga/banner.jpg" />
                  </div>
                  <div class="detail">
                    <h1 class="text-nowrap">{{item.product_name}}</h1>
                    <p>￥{{item.list_price}}</p>
                  </div>
                </router-link>
              </div>
              <!--item end-->
            </div>
            <div v-if="list.length<=0">
              <Norecord></Norecord>
            </div>
            <Pages :total="total" :pagechange="change" :size="12" :current="page"></Pages>
          </div>
        </div>
      </div>
    </div>
    <!-- :style="list.length<=4?'position: fixed;bottom:0':''" -->
    <FooterDes v-if="!show_ie"></FooterDes>
	<HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import pages from "../../components/Page";
import norecord from "../../components/NoRecord";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
    FooterDes: footer,
    Pages: pages,
	Norecord: norecord,
	HintIE:HintIE
  },
  data() {
    return {
      cate_id: 0,
      row: [],
      cate_list: [],
      list: [],
      total: 0,
	  page: 1,
	  show_ie:false
    };
  },
  methods: {
	isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)this.show_ie = true; //不支付IE
    },
    change: function(page) {
      window.scrollTo({//置顶
        top:0
      })
      this.page = page;
      this.getProductList(this.cate_id, page);
    },
    changeTab: function(cate_id) {
      this.cate_id = cate_id;
      this.getProductList(cate_id, 1);
    },
    getProductCateList: function() {
      var that = this;
      getData(config.apimethod.getProductCateList, function(res) {
        var data = res.data;
        that.cate_list = data;
      });
    },
    getProductList: function(cate_id, page) {
      var that = this;
      if (cate_id == undefined) {
        cate_id = 0;
      }
      that.page = page;
      getData(
        config.apimethod.getProductList +
          "?page=" +
          page +
          "&cate_id=" +
          cate_id + "&size=12",
        function(res) {
          that.list = res.data.data;
          that.total = res.data.total;
          // console.log(that.total)
        }
      );
    }
  },
  mounted() {
    this.getProductCateList();
    this.getProductList(0, 1);
    this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/index.vue